import React from "react";

interface Column {
	key: string;
	name: string;
	width?: number;
	getValue?: (key: string, value: any, index: number) => any;
}

interface DataTableProps {
	columns: Column[];
	data: any[];
	className?: string;
}

const DataTable: React.FC<DataTableProps> = ({
	columns,
	data,
	className = "",
}) => {
	return (
		<div className="w-full overflow-x-auto">
			<table className={`min-w-full divide-y divide-gray-200 ${className}`}>
				<thead className="bg-gray-50">
					<tr>
						{columns.map((column) => (
							<th
								key={column.key}
								scope="col"
								className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
								style={{ width: column.width ? `${column.width}px` : "auto" }}
							>
								{column.name}
							</th>
						))}
					</tr>
				</thead>
				<tbody className="bg-white divide-y divide-gray-200">
					{data.map((row, rowIndex) => (
						<tr
							key={rowIndex}
							className={rowIndex % 2 === 0 ? "bg-white" : "bg-gray-50"}
						>
							{columns.map((column) => (
								<td
									key={`${rowIndex}-${column.key}`}
									className="px-6 py-4 whitespace-nowrap text-center text-xs"
									style={{ width: column.width ? `${column.width}px` : "auto" }}
								>
									{column.getValue
										? column.getValue(column.key, row[column.key], rowIndex)
										: row[column.key] || "-"}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default DataTable;
